import { render, staticRenderFns } from "./TopSearch.vue?vue&type=template&id=5c85e48c"
import script from "./TopSearch.vue?vue&type=script&lang=js"
export * from "./TopSearch.vue?vue&type=script&lang=js"
import style0 from "./TopSearch.vue?vue&type=style&index=0&id=5c85e48c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports